<template>
    <td-dialog :title="$t(title)" :before-close="cancel" :visible.sync="dialogTypeVisible" :width="LeveWidth + 'px'" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" :label-width="labelWidth + 'px'">
            <el-form-item :label="$t('common.NAME')" prop="sName">
                <td-input v-model="formInfo.sName" maxlength="12"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.PARENT_GROUP')" prop="sParentId">
                <td-tree-select
                    ref="TdAlarmTypeTree"
                    :treeList="alarmTypeList"
                    :lazyloading="lazyloading"
                    :defaultProps="defaultProps"
                    :isSingleCheck="isSingleCheck"
                    :inputShow="inputShow"
                    :nodeKey="nodeKey"
                    :expandAll="expandAll"
                    :multiple="false"
                    @isChosen="isChosen"
                    :popoverShow="alarmTypeShow"
                    :refreshIconShowSel="false"
                ></td-tree-select>
            </el-form-item>
            <el-form-item :label="$t('common.DESCRIPTION')" prop="sDescribe">
                <td-input v-model="formInfo.sDescribe" type="textarea" maxlength="100"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: ['title', 'dialogTypeVisible', 'editItem', 'isAddData'],
    created() {
        this.initSelect();
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        }
    },
    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },
    watch: {
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.LeveWidth = 310 + (Number(newVal) == 14 ? 0 : Number(newVal) + 120);
                this.labelWidth = 70 + (Number(newVal) == 14 ? 0 : Number(newVal) + 30);
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    // 定义变量
    data() {
        let validateSName = (rule, value, callback) => {
            let param = {
                sName: value
            };
            if (!this.isAddData) {
                param.sId = this.editItem.id;
            }
            api.checkRepeat(param, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    callback(response.data.statusMessage);
                    this.saveLoading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        return {
            labelWidth: 70,
            LeveWidth: 310,
            // mq表单信息
            formInfo: {
                sName: '',
                sDescribe: ''
            },
            alarmTypeList: [],
            currentNode: null,
            lazyloading: false,
            isSingleCheck: true,
            inputShow: false,
            nodeKey: 'id',
            expandAll: true,
            saveLoading: false,
            defaultProps: {
                children: 'children',
                label: 'typeName',
                id: 'id'
            },
            alarmTypeShow: true,
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('regex.PLEASE_ENTER_NAME_AlARM_LEVEL'), trigger: 'blur' },
                    { min: 1, max: 12, message: this.$t('regex.PLEASE_ENTER_NAME_AlARM_LEVEL') },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('regex.NAME_ILLEGAL_AlARM_LEVEL') },
                    { validator: validateSName, trigger: 'blur' }
                ],
                sDescribe: [{ min: 1, max: 100, message: this.$t('error.ERROR_DESCRIPTION_MAX_LENGTH'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        initSelect() {
            api.getAlarmTypeTree('', response => {
                this.alarmTypeList = response.data.content;
            });
        },
        // 初始化编辑数据
        initEditData() {
            this.formInfo.sName = this.editItem.typeName;
            this.initAlarmType();
            this.formInfo.sDescribe = this.editItem.sDescribe;
        },
        // 初始化上级类型
        initAlarmType: function() {
            this.$nextTick(function() {
                if (this.editItem.parentId && this.editItem.parentId !== '') {
                    let obj = {};
                    obj.typeName = this.editItem.parentTypeName;
                    obj.id = this.editItem.parentId;
                    this.$refs.TdAlarmTypeTree.dataDisplay([obj]);
                }
            });
        },
        // 上级类型选择时执行的方法
        isChosen(data) {
            if (!this.isAddData && this.alarmTypeList.length > 0) {
                let selectFlag = true;
                let sonId = [];
                this.currentNode = null;
                this.getAlarmTypeNode(this.editItem.id, this.alarmTypeList);
                if (this.currentNode != null) {
                    this.getAlarmTypeSon(this.currentNode, sonId);
                    if (sonId.indexOf(data.id) > -1) {
                        selectFlag = false;
                        this.$message({ showClose: true, message: this.$t('pgMessage.NOT_CHOOSE_MYSELF_OR_SON_GROUP'), type: 'warning' });
                    }
                }
                this.$refs.TdAlarmTypeTree.isSelect(selectFlag);
            } else {
                this.$refs.TdAlarmTypeTree.isSelect(true);
            }
        },
        // 获取编辑类型节点
        getAlarmTypeNode(id, node) {
            for (let i = 0; i < node.length; i++) {
                if (node[i].id === id) {
                    this.currentNode = node[i];
                    return;
                }
                if (node[i].children != null) {
                    this.getAlarmTypeNode(id, node[i].children);
                }
            }
        },
        // 获取编辑类型所有子节点
        getAlarmTypeSon(node, sonId) {
            sonId.push(node.id);
            if (node.children != null) {
                for (let i = 0; i < node.children.length; i++) {
                    this.getAlarmTypeSon(node.children[i], sonId);
                }
            }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    let alarmTypeNode = this.$refs.TdAlarmTypeTree.getSelectedNodes();
                    let content = {
                        sId: this.isAddData ? '' : this.editItem.id,
                        sName: this.formInfo.sName,
                        sParentId: alarmTypeNode ? alarmTypeNode.id : '',
                        sDescribe: this.formInfo.sDescribe
                    };
                    api.saveAlarmType(content, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/saveAlarmType', response.data.statusMessage);
                            this.saveLoading = false;
                            return;
                        }
                        this.saveLoading = false;
                        let message = this.$t('common.ADD_SUCCESS');
                        if (!this.isAddData) {
                            message = this.$t('common.MODIFY_SUCCESS');
                        }
                        this.$message({ showClose: true, message: message, type: 'success' });
                        this.typeDialogClose();
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.$emit('typeDialogClose');
            this.$refs['formInfo'].resetFields(); // 重置表单数据
        },
        // 关闭窗口之前需要调用的方法
        typeDialogClose() {
            this.cancel();
            this.$emit('submit');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
